export default {
  items: [
    {
      name: 'Dashboard',
      url: '/corporate/dashboard',
      icon: 'icon-speedometer',
    },
    {
      name: 'Manage Corporate',
      icon: 'icon-people',
      children: [
        {
          name: 'Update Details',
          url: '/corporate/manage',
          icon: 'icon-star',
        },
        {
          name: 'Manage Branches',
          url: '/corporate/branch',
          icon: 'icon-home',
        },
        {
          name: 'Manage Buildings',
          url: '/corporate/building/manage',
          icon: 'icon-home',
        },
        {
          name: 'Manage Departments',
          url: '/corporate/department',
          icon: 'icon-star',
        },
      ]
    },
    // {
    //   name: 'Manage Buildings',
    //   icon: 'icon-home',
    //   children: [
    //     {
    //       name: 'Create Building',
    //       url: '/corporate/locations/manage',
    //       icon: 'icon-star',
    //     },
    //     {
    //       name: 'View All Buildings',
    //       url: '/corporate/locations/view',
    //       icon: 'icon-star',
    //     }
    //   ]
    // },
    {
      name: 'Manage Users',
      icon: 'icon-people',
      children: [
        {
          name: 'Create Public Users',
          url: '/corporate/users/create',
          icon: 'icon-star',
        },
        {
          name: 'Create Corporate Users',
          url: '/corporate/users/create_corporate',
          icon: 'icon-star',
        },
        {
          name: 'View All Users',
          url: '/corporate/users/view',
          icon: 'icon-star',
        },
        // {
        //   name: 'Manage VIP Users',
        //   icon: 'icon-people',
        //   url: '/corporate/VIPManage',
        // },
        {
          name: 'Manage System Users',
          icon: 'icon-people',
          url: '/corporate/systemusers',
        },

      ]
    },

    // {
    //   name: 'User Groups',
    //   url: '/corporate/usergroups',
    //   icon: 'icon-note',
    // },

    {
      name: 'Reports',
      url: '/corporate/report',
      icon: 'icon-note',
      children: [
        {
          name: 'View SMS',
          url: '/corporate/report/view_sms',
          icon: 'icon-chart',
        },
        {
          name: 'View Login Details',
          icon: 'icon-people',
          url: '/corporate/report/logindetails',
        }
        // ,{
        //   name: 'View Summary Report',
        //   icon: 'icon-people',
        //   url: '/corporate/report/summaryreport',
        // }
      ],
    },
    {
      name: 'Notifications',
      icon: 'icon-bell',
      url: '/corporate/notifications',
      children: [
        {
          name: 'Single User Notification',
          url: '/corporate/notifications/single/create', // ok 1
          icon: 'icon-bell',
        },
        {
          name: 'Category Notification',
          url: '/corporate/notifications/category/create', // ok 1
          icon: 'icon-bell',
        }
      ]
    },
    {
      name: 'User Categorization',
      icon: 'icon-people',
      url: '/corporate/user-categorization',
    }
  ],
};
